import CartItem from "./CartItem";
import _ from "lodash";

export default class Cart {
  id;
  items;
  price;
  orderNumber;
  poNumber;
  shipDate;
  shipVia;
  overrideDealerName;
  overrideDealerEmails;
  billTo;
  shipTo;
  notes;
  discountPercentage;
  freight;
  pricelist;
  customOrderSettings;
  warnings;
  errors;

  constructor(cartWire, people, products, imageByNameLowerCase) {
    var productBySku = _.keyBy(products, product => product.sku);

    this.id = cartWire.Prp_Dto_ObjectId;
    this.items = cartWire.Prp_Dto_Items.map(itemWire => new CartItem(itemWire, null, productBySku, imageByNameLowerCase));
    this.price = cartWire.Prp_Dto_SubTotal;
    this.orderNumber = cartWire.Prp_Dto_OrderNumber;
    this.poNumber = cartWire.Prp_Dto_PONumber;
    this.shipDate = cartWire.Prp_Dto_ShipDate;
    this.shipVia = cartWire.Prp_Dto_ShipVia;
    this.overrideDealerName = cartWire.Prp_Dto_OverrideDealerName;
    this.overrideDealerEmails = cartWire.Prp_Dto_OverrideDealeEmails;
    this.billTo = cartWire.Prp_Dto_BillTo;
    this.shipTo = cartWire.Prp_Dto_ShipTo;
    this.notes = cartWire.Prp_Dto_Notes;
    this.discountPercentage = cartWire.Prp_Dto_DiscountPercentage;
    this.freight = cartWire.Prp_Dto_Freight;
    this.pricelist = cartWire.Prp_Dto_Pricelist;
    this.customOrderSettings = cartWire.Prp_Dto_CustomOrderSettings;
    this.warnings = cartWire.Prp_Dto_Warnings;
    this.errors = cartWire.Prp_Dto_Errors;

    people.forEach(person => person.process(this, productBySku));
  }
}
